import { DropdownMenu } from '../form';
import { Icon } from '../UI';

export const Options = ({
  className = '',
  tooltipClassName = '',
  options,
  onSelect,
}: {
  className?: string;
  tooltipClassName?: string;
  options: string[];
  onSelect: (value: string) => void;
}) => {
  return (
    <DropdownMenu
      dropdownClassName={className}
      dropdownTooltipClassName={`
        ${tooltipClassName}
        bg-white
        border-solid
        border-grey-10
        border-1
        shadow-md
      `}
      handleClick={onSelect}
      hideOnItemClick
      dropdownItems={options}
    >
      <Icon svgName="options" id={'options-menu'} />
    </DropdownMenu>
  );
};
